import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiLock, FiClock, FiAlertTriangle } from "react-icons/fi";

function UnderConstruction() {
  const [timeLeft, setTimeLeft] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    if (timeLeft <= 0) {
      navigate("/");
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg">
        <div className="flex justify-center mb-4">
          <FiAlertTriangle className="text-lg" style={{ color: "#363062" }} />
        </div>

        <h1
          className="text-lg font-semibold text-center mb-2"
          style={{ color: "#363062" }}
        >
          Access Denied
        </h1>

        <p className="text-sm text-gray-600 text-center mb-4">
          You do not have access to this page
        </p>

        <div className="mt-4 p-3 bg-gray-50 rounded flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FiClock className="text-sm" style={{ color: "#8FCD00" }} />
            <span className="text-sm">Redirecting in</span>
          </div>
          <div
            className="flex items-center justify-center w-7 h-7 rounded-full text-sm font-medium"
            style={{ backgroundColor: "#363062", color: "white" }}
          >
            {timeLeft}
          </div>
        </div>

        <button
          onClick={() => navigate("/")}
          className="w-full mt-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none"
          style={{ backgroundColor: "#8FCD00" }}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
}

export default UnderConstruction;
